module.exports = __webpack_public_path__ + "media/images/emoticons/cute-67c607daa9d35dedec696b2da1cf6231.gif";